/**
 * Vídeos curtos dos primeiros passos (30 a 60 s, tela real, legenda embutida). Cole o link do YouTube (pode ser
 * não listado) ou do Vimeo: enquanto a URL estiver vazia, o botão "Ver como faz" daquele passo não aparece.
 */
export interface VideoOnboarding { titulo: string; duracao: string; url: string; }

export const VIDEOS_ONBOARDING: Record<string, VideoOnboarding> = {
  cardapio: {titulo: 'Como trazer seu cardápio', duracao: '0:40', url: ''},
  loja: {titulo: 'Entrega, retirada e taxa', duracao: '0:35', url: ''},
  pagamento: {titulo: 'Formas de pagamento e Pix', duracao: '0:30', url: ''},
  receber: {titulo: 'Som, aviso e onde receber', duracao: '0:30', url: ''},
  impressora: {titulo: 'Ligar a impressora térmica', duracao: '0:55', url: ''},
  extensao: {titulo: 'Instalar a extensão do WhatsApp', duracao: '0:50', url: ''},
  teste: {titulo: 'Tirando seu primeiro pedido', duracao: '0:45', url: ''}
};

export function videoOnboarding(id: string): VideoOnboarding | null {
  const video = VIDEOS_ONBOARDING[id];
  return video && urlDeIncorporacao(video.url) ? video : null;
}

/** youtube.com/watch?v=, youtu.be/, /shorts/ e vimeo.com/<id> viram o endereço do player. */
export function urlDeIncorporacao(url: string): string | null {
  const texto = String(url || '').trim();
  if (!texto) return null;
  const youtube = texto.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  if (youtube) return `https://www.youtube-nocookie.com/embed/${youtube[1]}?rel=0&modestbranding=1&cc_load_policy=1`;
  const vimeo = texto.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return null;
}
